/**
 * <MultiLevelSideMenu 
 *		// please describe props here
 *	/>
 *
 * This is...
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import objectPath from "object-path";
import './MultiLevelSideMenu.scss';

class MultiLevelSideMenu extends React.Component {
  constructor(props) {
    super(props);
  
    this.state = {
      currentMenu: props.menu,
      menuHistory: [],
    }
  
    this.backToPrevious = this.backToPrevious.bind(this);
  }

  componentWillMount() {
    this.props.getMethodsOnLoad({
      getPreviousMenu: this.getPreviousMenu.bind(this),
      backToPrevious: this.backToPrevious.bind(this),
    });
  }

  getPreviousMenu() {
    const {
      menuHistory,
    } = this.state;

    if (menuHistory.length > 0) {
      return menuHistory[menuHistory.length - 1];
    } else {
      return;
    }
  }

  backToPrevious() {
    let menuHistory = _.cloneDeep(this.state.menuHistory);

    const previousMenu = this.getPreviousMenu();

    const currentMenu = _.cloneDeep(previousMenu);

    this.setState({
      transitionBack: true,
    });

    setTimeout(()=>{
      menuHistory.splice(menuHistory.length - 1, 1);
      this.setState({
        menuHistory,
        currentMenu,
      });
      setTimeout(()=>{
        this.setState({
          transitionBack: false,
        });
      }, 50);
    }, 500);
    
  }

  selectSideMenu(currentMenu) {
    return ()=>{
      this.setState({
        transitionBack: true,
      });
      
      setTimeout(()=>{
        this.setState({
          menuHistory: [...this.state.previousMenu, _.cloneDeep(this.state.currentMenu)],  
          currentMenu,
        });
        setTimeout(()=>{
          this.setState({
            transitionBack: false,
          });
        }, 50);
      }, 500);
    }
  }

  render() {
    const {
      currentMenu,
      transitionBack,
    } = this.state;

    const {
      items = [],
      title,
      component,
      width,
    } = this.state.currentMenu;

    const previousMenu = this.getPreviousMenu();

    const style = typeof width == 'undefined' ? {} : { width } ;

    return (
      <div className='MultiLevelSideMenu' style={style}>
        <div className='MultiLevelSideMenu--content'>
          <div className={classnames('MultiLevelSideMenu--slidable', { transitionBack })}>
            <div className='MultiLevelSideMenu--back' >
              { previousMenu && <a onClick={this.backToPrevious}>{previousMenu.title}</a> }
            </div>
            <label>{title}</label>
            { typeof component == 'function' && component() }
            { items.length > 0 &&
              <ul className='MultiLevelSideMenu--menu'>
                {items.map((menu)=>{
                  const {
                    title,
                    icon,
                  } = menu; 
                  return (
                    <li className='MultiLevelSideMenu--menu--item'>
                      <span className='MultiLevelSideMnu--label' onClick={this.selectSideMenu(menu)}>{title}</span>
                      <i className={classnames('icon', icon)}></i>
                    </li>
                  );
                })}
              </ul>
            }
          </div>
        </div> 
      </div>
    )
  }
}

export default MultiLevelSideMenu;



// WEBPACK FOOTER //
// ./src/containers/pages/Website/WebsiteSideMenu/index.js